import { render, staticRenderFns } from "./Interfaces.vue?vue&type=template&id=4a2746c5&scoped=true&"
import script from "./Interfaces.vue?vue&type=script&lang=ts&"
export * from "./Interfaces.vue?vue&type=script&lang=ts&"
import style0 from "./Interfaces.vue?vue&type=style&index=0&id=4a2746c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2746c5",
  null
  
)

export default component.exports